import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { NOTIFICATION_TYPES } from '../../../constants';

type UseDecisionMakerRecommendationReturn =
	| { type: (typeof NOTIFICATION_TYPES)['decisionMakerRecommendation'] }
	| undefined;
export function useDecisionMakerRecommendation(): UseDecisionMakerRecommendationReturn {
	const {
		data: {
			petition,
			featureConfigs: { starterDashboardDMRecommenderEnabled },
		},
	} = useStarterDashboardV2PageData();

	// ALERTS: comment this line
	// if fcm is disabled, hide the notification
	if (!starterDashboardDMRecommenderEnabled) return undefined;

	// ALERTS: comment this line
	// if petition has a decision maker, hide the notification
	if (petition.decisionMakersConnection.totalCount !== 0) return undefined;

	// ALERTS: comment this line
	// if petition has no recommended decision makers, hide the notification
	if (petition.recommendedDecisionMakers.length === 0) return undefined;

	return { type: NOTIFICATION_TYPES.decisionMakerRecommendation };
}
